import { buildCssInlineBase } from './build-css-inline-base';
import { buildCssInlineSsm } from './build-css-inline-ssm';
export function buildCssInline({ css, experiments }) {
    return [buildCssInlineBase({ experiments }), buildCssInlineSsm(css)].join('');
}
//# sourceMappingURL=build-css-inline.js.map